import React, { useEffect,useRef } from "react";
import axios from 'axios';
import swal from "sweetalert";
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import HubungiKami from '../components/HubungiKami';

function TermsWellground(){

    const renderAfterCalled = useRef(false);

    useEffect(() => {
        if (!renderAfterCalled.current) {
            getData()
        }
        renderAfterCalled.current = true;
    }, [])

    const getData = async () => {
        await axios.get(`${process.env.REACT_APP_API_WGN}app/api/wgn/v1/guest/tnc
`, {
        headers: {
            'mobileAppVersion': "webApps",
        }
        })
        .then(response => {
            document.querySelector("#privasi").insertAdjacentHTML("afterend",response.data);
        })
        .catch(error => {
            swal("Maaf","Terjadi Kesalahan, mohon refresh ulang.", "warning");
        })
    }

    return (
        <>
            {<Header/>}
            <section className="page-cover pt-5 mb-5" style={{ background: '#0E5442' }}>
                <h1 className="page-title" style={{ color: '#fff' }}>
                    Terms & Conditions
                </h1>
            </section>
            <div className="containerfluid mb-5">
                <div className="col-md-8 offset-md-2" style={{marginTop:'-10%'}}>
                    <div className="card">
                        <div className="card-body">
                            <div class="container p-3" style={{textAlign:'justify'}} id="privasi">
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <HubungiKami />
        </>
    );
}
  
export default TermsWellground;